import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
}

export const Eyebrow: FC<EyebrowProps> = ({ children, className }): ReactNode => {
    return (
        <p className={cn('text-[0.72rem] font-bold uppercase tracking-[0.16em] text-brand', className)}>
            {children}
        </p>
    )
}

interface SectionIntroProps {
    eyebrow: string
    title: ReactNode
    intro?: ReactNode
    align?: 'left' | 'center'
    id?: string
    className?: string
}

const SectionIntro: FC<SectionIntroProps> = ({
    eyebrow,
    title,
    intro,
    align = 'left',
    id,
    className
}): ReactNode => {
    const centered = align === 'center'

    return (
        <div className={cn('reveal max-w-4xl', centered && 'mx-auto text-center', className)}>
            <Eyebrow>
                {eyebrow}
            </Eyebrow>

            <h2
                id={id}
                className='mt-4 font-heading text-[clamp(2.2rem,4.2vw,3.4rem)] font-extrabold leading-[1.03] tracking-[-0.035em] text-balance text-foreground'
            >
                {title}
            </h2>

            {intro && (
                <p className={cn('mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg', centered && 'mx-auto')}>
                    {intro}
                </p>
            )}
        </div>
    )
}

export default SectionIntro
